import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function Title({ as, className, ...rest }) {
    const Tag = (as ?? "h2");
    return _jsx(Tag, { className: cn("fwfa-title", className), ...rest });
}
//# sourceMappingURL=Title.js.map